(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laudati-story"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lst-film__play');
    if (!b) return;
    var f = b.parentElement;
    var i = document.createElement('iframe');
    i.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(f.getAttribute('data-yt')) + '?autoplay=1&rel=0&playsinline=1';
    i.title = f.getAttribute('data-yt-title') || 'video';
    i.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    i.allowFullscreen = true;
    i.referrerPolicy = 'strict-origin-when-cross-origin';
    f.replaceChildren(i);
    i.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
